<template>
  <div class="d-flex justify-end align-center pa-3 font-14">
    <span style="margin-right: 13px;" v-if="showSetMax">จำนวนแถวต่อหน้า</span>
    <v-select 
      v-model="limit" 
      :items="itemsMax"
      style="max-width: 60px; max-height: 20px; margin-right: 13px; bottom: 14px;"
      @input="changeLimit"
      hide-details
      v-if="showSetMax"
    ></v-select>
    <span v-if="showSetMax">รายการ</span>
    <v-icon class="icon-border ml-2" @click="prePagination">
      mdi-chevron-left </v-icon
    >{{ pagtotals === 0 ? 0 : isPage }}/{{ paginationLength(pagtotals)
    }}<v-icon class="icon-border mr-2" @click="nextPagination">
      mdi-chevron-right
    </v-icon>
    <v-divider vertical class="mr-2" /> แสดง
    <span class="icon-border px-2 mx-2 font-14" style="color: #00A99D">
      {{ showItemMin() }}-{{ showItemMax() }}
    </span>
    ของ {{ pagtotals }} รายการ
  </div>
</template>

<script>
export default {
  props: {
    totals: {
      type: Number,
      default: 1,
    },
    isPage: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 10,
    },
    showSetMax: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      page: 1,
      itemMin: 1,
      itemsMax: [
        10,
        50,
        100,
        500
      ],
      limit: 20
    }
  },
  computed: {
    pagtotals() {
      return this.totals
    },
  },
  created () {
    this.limit = this.max
  },
  methods: {
    paginationLength(total = 0) {
      if (total % this.max === 0) {
        return total / this.max
      } else return Math.floor(total / this.max) + 1
    },
    prePagination() {
      this.page = this.isPage
      if (this.isPage !== 1) {
        this.page -= 1
        this.itemMin -= this.max
        this.$emit("page", this.page)
      }
    },
    nextPagination() {
      //
      this.page = this.isPage
      // console.log(parseInt(this.totals / 10));
      if (this.totals / this.max > this.isPage)
        if (
          this.isPage <= Math.floor(this.pagtotals / this.max) &&
          this.pagtotals > this.max
        ) {
          this.page += 1
          this.itemMin += this.max
          this.$emit("page", this.page)
        }
    },
    showItemMin() {
      if (this.isPage === 1) this.itemMin = 1
      if (this.pagtotals === 0) return 0
      return this.itemMin
    },
    showItemMax() {
      if (this.itemMin + this.max - 1 > this.pagtotals) return this.pagtotals
      return this.itemMin + this.max - 1
    },
    changeLimit () {
      this.$emit("setLimit", this.limit)
    }
  },
}
</script>

<style scoped>
::v-deep > .v-select > .v-input__control > .v-input__slot > .v-select__slot {
  height: 20px;
}

::v-deep > .v-select > .v-input__control > .v-input__slot > .v-select__slot > .v-input__append-inner {
  position: relative;
  bottom: 6px;
}
</style>
